import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_COMPONENT_TRANSPARENT',
  GET: 'GET_COMPONENT_TRANSPARENT',
  CREATE: 'CREATE_COMPONENT_TRANSPARENT',
  EDIT: 'EDIT_COMPONENT_TRANSPARENT',
  DELETE: 'DELETE_COMPONENT_TRANSPARENT',
  DUPLICATE: 'DUPLICATE_COMPONENT_TRANSPARENT',
  CLEAR_ERROR: 'CLEAR_ERROR_COMPONENT_TRANSPARENT',
};

export const listComponentTransparent = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_COMPONENT_TRANSPARENT,
      params: {
        search: filtered,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
          : null,
        is_public: isPublic,
      },
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const getComponentTransparent = id => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_COMPONENT_TRANSPARENT}${id}/`,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createComponentTransparent = (name, heatDissipationId, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('heat_dissipation_id', heatDissipationId);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `oq_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_COMPONENT_TRANSPARENT,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};
export const createComponentWithMaterials = (name,  heatDissipationId, description, image,material_list)=>{
  const formData = new FormData();
  formData.set('name', name);
  formData.set('heat_dissipation_id', heatDissipationId);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `oq_${new Date().valueOf()}`);
  formData.set('material_list', JSON.stringify(material_list));
  return{
    type: ACTION.CREATE,
    payload : RestClient.request({
      method: 'post',
      url: Constants.API_COMPONENT_TRANSPARENT,
      data: formData,
    }).catch(err => Promise.reject(err.response.data))
  }
}
export const editComponentTransparent = (id, name, heatDissipationId, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (heatDissipationId) formData.set('heat_dissipation_id', heatDissipationId);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `oq_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_COMPONENT_TRANSPARENT}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteComponentTransparent = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_COMPONENT_TRANSPARENT}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateComponentTransparent = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_COMPONENT_TRANSPARENT}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const clearErrorComponentTransparent = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/redux/component_transparent/component_actions.js